import { styled } from '@mui/material';
import Promo_List from 'src/components/adminPromo/Promo_List';

const PageWrapper = styled('div')(({theme})=>({
  margin : '30px 30px',
  backgroundColor:'white',
  borderRadius:'10px',
  height: 'calc(100vh - 126px)', // 필요시 조정
  overflow: 'hidden', // 전체적으로 overflow 방지
}))

const AdAchivePage = () => {
  return (
    <PageWrapper>
      <Promo_List/>
    </PageWrapper>
  )
}

export default AdAchivePage